import { useHistory, useLocation } from 'react-router-dom';
import { useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import MobileNavbar from '../mobile/Navbar/Navbar';
import Navbar from '../laptop/Navbar/Navbar';
import isMobileViewHook from '../../hooks/isMobileView';
import Sidebar from '../mobile/Sidebar/Sidebar';
import classes from './Layout.module.css';

const Layout = ({ children }) => {
  const [showSidebar, setShowSidebar] = useState(false);
  const isMobileView = isMobileViewHook();
  const layoutRef = useRef();
  const history = useHistory();
  const location = useLocation();
  const hub = useSelector((state) => state.hub.hub);
  if (!hub) return null;
  const { backgroundImage, backgroundImageMobile } = hub;
  const scrollHandler = () => {
    if (location.pathname === '/')
      setTimeout(() => {
        const scroll = layoutRef.current.scrollTop;
        if (scroll > 350) {
          history.push('/#home');
        } else {
          history.push('/');
        }
      }, 300);
  };

  const toggleSidebar = () => {
    setShowSidebar((prevShowSidebar) => !prevShowSidebar);
  };
  // eslint-disable-next-line no-nested-ternary
  const backgroundImageHome = isMobileView
    ? backgroundImageMobile
      ? backgroundImageMobile[0].url
      : backgroundImage[0].formats.large.url
    : backgroundImage[0].url;
  return (
    <div style={{ height: '100vh', width: '100%' }}>
      <div
        style={{ height: '100%', width: '100%' }}
        className={classes.content}
      >
        <Sidebar
          show={isMobileView && showSidebar}
          onCloseSidebar={toggleSidebar}
        />
        {isMobileView ? (
          <MobileNavbar onShowSidebar={toggleSidebar} />
        ) : (
          <Navbar />
        )}
        {children}
      </div>
      <div
        style={{
          backgroundImage: `url(${backgroundImageHome})`,
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          height: '100vh',
          position: 'fixed',
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          zIndex: -1,
          display: 'block',
        }}
        className={classes.container}
        onScroll={scrollHandler}
        ref={layoutRef}
      />
    </div>
  );
};
Layout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
  ]).isRequired,
};
export default Layout;
